var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertInformationNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 58.6667C17.272 58.6667 5.33337 46.728 5.33337 32C5.33337 17.272 17.272 5.33333 32 5.33333C46.728 5.33333 58.6667 17.272 58.6667 32C58.6667 46.728 46.728 58.6667 32 58.6667ZM32 53.3333C37.658 53.3333 43.0842 51.0857 47.085 47.0849C51.0858 43.0842 53.3334 37.6579 53.3334 32C53.3334 26.342 51.0858 20.9158 47.085 16.9151C43.0842 12.9143 37.658 10.6667 32 10.6667C26.3421 10.6667 20.9159 12.9143 16.9151 16.9151C12.9143 20.9158 10.6667 26.342 10.6667 32C10.6667 37.6579 12.9143 43.0842 16.9151 47.0849C20.9159 51.0857 26.3421 53.3333 32 53.3333ZM29.3334 42.6667C29.3334 41.1939 30.5273 40 32 40C33.4728 40 34.6667 41.1939 34.6667 42.6667C34.6667 44.1394 33.4728 45.3333 32 45.3333C30.5273 45.3333 29.3334 44.1394 29.3334 42.6667ZM29.3334 21.3333C29.3334 19.8606 30.5273 18.6667 32 18.6667C33.4728 18.6667 34.6667 19.8606 34.6667 21.3333V34.6667C34.6667 36.1394 33.4728 37.3333 32 37.3333C30.5273 37.3333 29.3334 36.1394 29.3334 34.6667V21.3333Z",
    fill: "#FF6600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertInformationNew);
export default __webpack_public_path__ + "static/media/alert-information-new.431e9d8c0486e1beb80723d23660cafc.svg";
export { ForwardRef as ReactComponent };